import React, { useMemo } from 'react';
import { useAuthStore, useModelStore } from '@/store';
import { useCurrentRoute } from '@/hooks/useCurrentRoute';
import SidebarListItemModel from './SidebarListItemModel';

function SidebarSavedModelsSection() {
  const route = useCurrentRoute();
  const favoriteModelIds = useAuthStore(state => state.user?.favoriteModelIds);
  const models = useModelStore(state => state.models);

  // Memoize the saved models list
  const savedModels = useMemo(() => {
    // Only map if we have both favoriteModelIds and models
    if (!favoriteModelIds?.length || !Object.keys(models)?.length) {
      return [];
    }
    return favoriteModelIds.map(id => models[id]).filter(Boolean);
  }, [favoriteModelIds, models]);

  if (!Array.isArray(savedModels) || savedModels.length === 0) {
    // console.log('No saved models, returning null');
    return null;
  }

  return savedModels.map(model => (
    <SidebarListItemModel
      key={model.id}
      id={model.id}
      title={model.name}
      href={`/m/${model.id}`}
      isActive={route.isModel(model.id)}
      createdAt={model.createdAt}
      imageUrl={model.logoPath || ''}
    />
  ));
}

export default React.memo(SidebarSavedModelsSection); 